import { NewTesEmployeeGetters } from './new-tes-employee.keys';
import format from 'date-fns/format';

export const getInitialState = () => {
  return {
    newTesEmployee: {
      created_at: format(new Date(), 'YYYY-MM-DD'),
      branch_name: '',
      commission_profiles: [],
      roles: [],
      departments: [],
      user: {
        first_name: '',
        last_name: '',
        preferred_name: '',
        email: '',
        email_alt: '',
        phone1: '',
        phone1_type: null,
        phone2: '',
        phone2_type: null,
        phone3: '',
        phone3_type: null
      }
    }
  };
};

export const newTesEmployeeStore = {
  state: getInitialState,
  getters: {
    [NewTesEmployeeGetters.NewTesEmployee]: state => {
      return state.newTesEmployee;
    }
  }
};
